module.exports = __webpack_public_path__ + "TotalTip-ad2e7468f608fc422ec55d6d7e2e63f2.png";